// src/components/vocab/VocabTimer.jsx
import React from 'react';

export default function VocabTimer({ timeLeft, total }) {
  const percentage = (timeLeft / total) * 100;
  
  const color = percentage > 60 
    ? 'bg-emerald-400' 
    : percentage > 30 
    ? 'bg-yellow-400' 
    : 'bg-red-500';

  const textColor = percentage > 60
    ? 'text-emerald-600'
    : percentage > 30
    ? 'text-yellow-600'
    : 'text-red-600';

  return (
    <div className="w-full max-w-sm flex items-center gap-3">
      {/* Número */}
      <span className={`text-2xl font-black tabular-nums w-8 text-center transition-colors duration-300 ${textColor}`}>
        {timeLeft}
      </span>

      {/* Barra */}
      <div className="flex-1 h-3 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-1000 ease-linear ${color}`}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Icono */}
      <span className="text-lg">⏱️</span>
    </div>
  );
}
